// @flow

import { graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeletePOApprovalRuleMutation($input: DeletePOApprovalRuleInput!) {
    deletePOApprovalRule(input: $input) {
      success
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      updater: (store) => {
        const deletedRuleId = options.variables.input.id;
        
        // Remove the rule from the poApprovalRules connection
        const root = store.getRoot();
        const connection = ConnectionHandler.getConnection(
          root,
          'POApprovalRules_poApprovalRules'
        );
        
        if (connection && deletedRuleId) {
          ConnectionHandler.deleteNode(connection, deletedRuleId);
        }
      },
    });
  },
};
